/*
 * Native Social Proof for the Dynamatic slide-cart (third-party app, rendered client-side).
 * Reads the current cart's metafields from the social-proof-cart-data section and injects the
 * compact widget under each line item — the native replacement for ConvertCart's cart social proof.
 * The /cart page and PDP are handled in Liquid (snippet + social-proof.js); this covers the app cart.
 */
(function () {
  'use strict';
  if (window.__aroSpCartBooted) return;
  window.__aroSpCartBooted = true;

  var data = null;      // { handle: {sold,viewed,repeat,happy} }
  var fetching = false;

  var ICONS = {
    sold: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    viewed: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>',
    repeat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 2l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>',
    happy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><path d="M9 9h.01M15 9h.01"/></svg>'
  };

  function itemHtml(key, inner) {
    return '<div class="aro-sp__item"><span class="aro-sp__icon">' + ICONS[key] + '</span><span class="aro-sp__text">' + inner + '</span></div>';
  }

  function buildWidget(d) {
    var parts = [];
    if (d.sold > 10) parts.push(itemHtml('sold', '<strong>' + d.sold + '+</strong> bought this recently'));
    if (d.viewed > 50) parts.push(itemHtml('viewed', '<strong>' + d.viewed + '+</strong> viewed this recently'));
    if (d.repeat > 20) parts.push(itemHtml('repeat', '<strong>' + d.repeat + '+</strong> customers buy this again &amp; again'));
    if (d.happy > 0) parts.push(itemHtml('happy', '<strong>' + d.happy + '%</strong> happy customers'));
    if (!parts.length) return null;
    var wrap = document.createElement('div');
    wrap.className = 'aro-sp aro-sp--compact';
    wrap.setAttribute('role', 'status');
    wrap.innerHTML = parts.join('');
    return wrap;
  }

  // Self-contained rotation (social-proof.js may not be loaded on this page).
  function startRotate(el) {
    if (el.__aroSpInit) return;
    el.__aroSpInit = true;
    var items = el.querySelectorAll('.aro-sp__item');
    if (items.length <= 1) return;
    el.classList.add('is-rotating');
    var i = 0;
    items[0].classList.add('is-active');
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  }

  function handleOf(li) {
    var m = (li.className || '').match(/handle-([a-z0-9\-]+)/i);
    return m ? m[1] : null;
  }

  function fetchData(cb) {
    if (fetching) return;
    fetching = true;
    fetch('/?section_id=social-proof-cart-data', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.getElementById('aro-sp-cart-data');
          data = el ? JSON.parse(el.textContent) : {};
        } catch (e) { data = {}; }
        fetching = false;
        if (cb) cb();
      })
      .catch(function () { fetching = false; });
  }

  function inject() {
    var lis = document.querySelectorAll('.dyn-line-item-parent');
    if (!lis.length) return;
    // (Re)fetch if we have no data, or the cart contains a handle we haven't loaded (item just added).
    var needFetch = !data;
    if (data) {
      for (var i = 0; i < lis.length; i++) {
        var h = handleOf(lis[i]);
        if (h && !(h in data)) { needFetch = true; break; }
      }
    }
    if (needFetch) { fetchData(inject); return; }

    lis.forEach(function (li) {
      if (li.querySelector('.aro-sp')) return;      // already injected
      var h = handleOf(li);
      if (!h) return;
      var d = data[h];
      if (!d) return;
      var w = buildWidget(d);
      if (!w) return;
      // Place under the title/price column (CC used the same anchor) so it sits below the
      // details, not squished into the image+details flex row. Fall back progressively.
      var titleCol = li.querySelector('.dyn-line-item-title-price-delete');
      if (titleCol && titleCol.parentNode) {
        titleCol.parentNode.insertBefore(w, titleCol.nextSibling);
      } else {
        var details = li.querySelector('.dyn-line-item-details') || li.querySelector('.dyn-line-item-single') || li;
        details.appendChild(w);
      }
      startRotate(w);
    });
  }

  // The app cart is injected/updated dynamically — watch the whole document and re-inject.
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (document.querySelector('.dyn-line-item-parent')) inject();
    }).observe(document.body, { childList: true, subtree: true });
  }
  // First pass in case the cart is already open.
  if (document.readyState !== 'loading') inject();
  else document.addEventListener('DOMContentLoaded', inject);
})();
